export default __webpack_public_path__ + "05e1e414ccd32945c1ea6d14bab44963c1af898daf37b9e68d8c14cf351c2dd3.svg";